<template lang="pug">
    .ui-content__item-page.ui-colors.ui-item-page
        h2.ui-item-page__title UI Color
        .ui-block
            .row
                .col-lg-12
                    h5.ui-item-page__sub-title Main color
                    .ui-color(v-for="(color, index) in ui_colors.main_color" :key="index")
                        .ui-color__item(:style="'background:' + color.hex")
                            .ui-color__text {{color.title}}
                            .ui-color__hex {{color.hex}}
        .ui-block
            .row
                .col-lg-12
                    h5.ui-item-page__sub-title Secondary color
                    .ui-color(v-for="(color, index) in ui_colors.secondary_color" :key="index")
                        .ui-color__item(:style="'background:' + color.hex")
                            .ui-color__text {{color.title}}
                            .ui-color__hex {{color.hex}}
        .ui-block
            .row
                .col-lg-12
                    h5.ui-item-page__sub-title Neutral Color
                    .ui-color(v-for="(color, index) in ui_colors.text_color" :key="index")
                        .ui-color__item(:style="'background:' + color.hex")
                            .ui-color__text {{color.title}}
                            .ui-color__hex {{color.hex}}
        .ui-block
            .row
                .col-lg-12
                    h5.ui-item-page__sub-title Border Color
                    .ui-color(v-for="(color, index) in ui_colors.border_color" :key="index")
                        .ui-color__item(:style="'background:' + color.hex")
                            .ui-color__text {{color.title}}
                            .ui-color__hex {{color.hex}}
        .ui-block
            .row
                .col-lg-6
                    h5.ui-item-page__sub-title Gradient
                    .ui-gradient-block.main-gradient


</template>

<script>
    let ui_colors = {
        main_color: [
            {title: 'primary',         hex: '#00b1ac'}
        ],
        secondary_color: [
            {title: 'secondary',                hex: '#006966'},
            {title: 'success',                  hex: '#7d9c01'},
            {title: 'warning',                  hex: '#f39c00'},
            {title: 'danger',                   hex: '#f33a15'},
            {title: 'info',                     hex: '#63828e'},
            {title: 'nmo',                      hex: '#e52b4e'},
            {title: 'cycle-tag',                hex: '#c8b573'},
            {title: 'theme-tag',                hex: '#9bc1c1'},
            {title: 'color-checkbox',           hex: '#547604'},
        ],
        text_color: [
            {title: 'Primary Text',             hex: '#000000'},
            {title: 'Regular Text',             hex: '#504f4f'},
            {title: 'Placeholder Text',         hex: '#999999'},
            {title: 'Secondary Text',           hex: '#bcbcbc'},
        ],
        border_color: [
            {title: 'Base Border',              hex: '#999999'},
            {title: 'Light Border',             hex: '#DEDEDE'},
            {title: 'Lighter Border',           hex: '#EAEAEA'},
            {title: 'Extra Light Border',       hex: '#FAFAFA'},
        ]
    };
    export default {
        data() {
            return {
                ui_colors: ui_colors,
                primary: '#409eff',
                secondary: '#6190e8',
                success: '#13CE66'
            }
        }
    };
</script>
